<div class="peoplefinder chrome-no-repaint">
  <ng-container *ngIf="!loading">
    <div class="container-fluid">
      <div class="row g-3">
        <div class="col-4">
          <div class="tile">
            <div class="content">
              <ng-container *ngIf="allUsers">
                <app-user-location-filter
                  [selectedUser]="selectedUser"
                  [hoveredUser]="hoveredUser"
                  [filteredUsers]="preFilteredUsersForLocation"
                  (updatedFilter)="onCountryFilterChanged($event)"
                  [users]="allUsers"></app-user-location-filter>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="tile">
            <div class="content">
              <ng-container *ngIf="allIdeas && preFilteredIdeasForTags">
                <app-word-cloud-filter
                  (updatedFilter)="onTagFilterChanged($event)"
                  [filteredIdeas]="preFilteredIdeasForTags"
                  [ideas]="allIdeas"></app-word-cloud-filter>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="tile">
            <div class="content">
              <ng-container *ngIf="sessions">
                <app-topic-filter
                  [allSessions]="sessions"
                  [filteredSessions]="preFilteredSessionsForTopics"
                  (updatedFilter)="
                    onTopicFilterChanged($event)
                  "></app-topic-filter>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="tile user-list">
            <div class="content">
              <ng-container *ngIf="allUsers">
                <app-user-filter
                  (userHoverEvent)="onUserHovered($event)"
                  (userSelectedEvent)="onUserSelected($event)"
                  [users]="allUsers"
                  (updatedFilter)="onUserFilterChanged($event)"
                  [filteredUsers]="
                    preFilteredUsersForUserList
                  "></app-user-filter>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="tile filtered-result-toggle">
            <div class="content">
              <app-filtered-results-toggle
                [ideaIdToSession]="ideaIdToSession"
                [users]="filteredUsers"
                [ideas]="filteredIdeas"></app-filtered-results-toggle>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="loading">
    <div class="peoplefinder-loading">
      <img
        alt
        id="wedavinci-logo"
        src="../../../assets/images/logo-no-type.svg" />
      <div id="loading-div">Loading Data</div>
    </div>
  </ng-container>
</div>
